import React from "react";

const DispatchManagement = () => {
  return <div><h1>Work In Progress......</h1></div>;
};

export default DispatchManagement;